import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { BoardContainer } from "./BoardContainer";
import ICandyScene from "../ICandyScene";
import { BoardScene } from "./BoardScene";
import { GameManager } from "../../GameManager";

export class BoardManager {

    public static currentInstance: BoardManager;

    public p1: { c: number, r: number };
    public p2: { c: number, r: number };

    private affectedOrbs: {
        eliminatedOrbs: Candy.EliminatedOrb[],
        mutatedOrbs: Candy.MutatedOrb[]
    };

    private displacementData: Candy.OrbDisplacementData[];
    private candyScene: ICandyScene;

    constructor(candyScene: ICandyScene) {

        BoardManager.currentInstance = this;

        this.candyScene = candyScene;

        this.p1 = null;
        this.p2 = null;

        GameVars.orbsMoving = false;
        GameVars.gameOver = false;
        GameVars.score = 0;
        GameVars.isLevelUp = 0;
        GameVars.paused = false;
        GameVars.paymentDone = false;

        let seed = GameVars.seed;
        let iPRNG = 0;
        let orbs = [];
        let numOrbs = 4;

        GameVars.candyEngine = new Candy.Engine(seed, iPRNG, orbs, numOrbs, GameVars.forcedCombo);

        GameVars.cols = GameVars.candyEngine.cols;
        GameVars.rows = GameVars.candyEngine.rows;

        GameVars.candyEngine.addEventListener(Candy.Event.MATCH, this.onMatch, this);
        GameVars.candyEngine.addEventListener(Candy.Event.REMATCH, this.onRematch, this);
        GameVars.candyEngine.addEventListener(Candy.Event.NO_REMATCH, this.onNoRematch, this);
        GameVars.candyEngine.addEventListener(Candy.Event.MISMATCH, this.onMismatch, this);
        GameVars.candyEngine.addEventListener(Candy.Event.NOT_ADJACENT_ORBS_SELECTED, this.onNotAdjacentOrbsSelected, this);
        GameVars.candyEngine.addEventListener(Candy.Event.RESHUFFLE, this.onReshuffle, this);

        GameManager.fecthSeed();

        (async () => {
            GameVars.startDate = await GameManager.api.getInitialDate();
            console.log(GameVars.startDate);
        })();
    }

    public pause(): void {

        GameVars.paused = true;

        this.candyScene.pause();
    }

    public resume(): void {

        GameVars.paused = false;

        this.candyScene.resume();
    }

    public removePaymentLayer(): void {

        GameVars.paused = false;
    }

    public onOrbSelected(p: { c: number, r: number }): void {

        if (this.p1 === null) {
            this.p1 = p;
            BoardContainer.currentInstance.onFirstOrbSelected();
        } else {

            this.p2 = p;

            GameVars.orbsMoving = true;

            GameVars.candyEngine.onOrbsSelected(this.p1, this.p2);

            this.candyScene.updateMoves();
        }
    }

    public onMatchAnimationCompleted(): void {

        BoardContainer.currentInstance.mutateOrbsAt(this.affectedOrbs.mutatedOrbs);
        BoardContainer.currentInstance.removeOrbsAt(this.affectedOrbs.eliminatedOrbs);
    }

    public spawnAndAnimateorbs(): void {

        if (GameVars.gameOver) {
            return;
        }

        BoardContainer.currentInstance.spawnAndAnimateOrbs(this.displacementData);
    }

    public onFallingOrbsAnimationCompleted(): void {

        setTimeout(function (): void {
            GameVars.candyEngine.checkBoard();
        }, 90);
    }

    public onMissMatchOrbReturnedToItsPosition(): void {

        GameVars.orbsMoving = false;
    }

    public onBoardReshuffled(): void {

        GameVars.paused = false;
    }

    public onClickClaim(): void {

        BoardScene.currentInstance.onClickClaim();
    }

    private onReshuffle(prevBoard: Candy.OrbData[][]): void {

        GameVars.paused = true;

        this.candyScene.reshuffle(prevBoard);
    }

    private onMatch(affectedOrbs: { eliminatedOrbs: Candy.EliminatedOrb[], mutatedOrbs: Candy.MutatedOrb[] }, displacementData: Candy.OrbDisplacementData[], cols: number, rows: number, score: number): void {

        this.affectedOrbs = affectedOrbs;
        this.displacementData = displacementData;

        GameVars.cols = cols;
        GameVars.rows = rows;
        GameVars.score = score;

        BoardContainer.currentInstance.onMatch();

        this.p1 = null;
        this.p2 = null;
    }

    private onRematch(
        affectedOrbs: {
            eliminatedOrbs: Candy.EliminatedOrb[],
            mutatedOrbs: Candy.MutatedOrb[]
        },
        displacementData: Candy.OrbDisplacementData[],
        cols: number,
        rows: number,
        score: number,
        rematchesCounter: number
    ): void {

        this.affectedOrbs = affectedOrbs;
        this.displacementData = displacementData;

        GameVars.cols = cols;
        GameVars.rows = rows;
        GameVars.score = score;

        BoardContainer.currentInstance.mutateOrbsAt(this.affectedOrbs.mutatedOrbs);
        BoardContainer.currentInstance.removeOrbsAt(this.affectedOrbs.eliminatedOrbs);

        this.candyScene.updateScore(affectedOrbs.eliminatedOrbs.length, rematchesCounter);
    }

    private onNoRematch(displacementData: Candy.OrbDisplacementData[], cols: number, rows: number, gameOver: boolean, score: number): void {

        if (GameVars.gameOver) {
            return;
        }

        if (displacementData !== null) {

            GameVars.levelingUp = true;

            const newCol = GameVars.cols !== cols;

            GameVars.cols = cols;
            GameVars.rows = rows;

            this.candyScene.onLevelUp(false, newCol);

            setTimeout(() => {
                BoardContainer.currentInstance.spawnAndAnimateOrbs(displacementData);
            }, 500);

            setTimeout(() => {
                GameVars.levelingUp = false;
            }, 1500);

        } else {

            this.onMovementCompleted();
        }

        if (gameOver) {
            this.onGameOver();
        }

        if (GameVars.isBattleWin) {
            this.onGameOver();
        }
    }

    private onMovementCompleted(): void {
        GameVars.orbsMoving = false;

        if (GameVars.candyEngine.moves % 5 === 0) {

            if (GameVars.candyEngine.moves > 0) {

                GameVars.candyEngine.setSeed(GameVars.seed);

                GameManager.fecthSeed();
            }
        }

        this.candyScene.onNoRematch(this.affectedOrbs.eliminatedOrbs.length);
    }

    private onGameOver(): void {

        GameVars.gameOver = true;
        GameManager.onGameOver();

        this.candyScene.onGameOver();
    }

    private onMismatch(): void {
        BoardContainer.currentInstance.onMissmatch();

        this.p1 = null;
        this.p2 = null;

        this.candyScene.setInactivityTimer(10000);
    }

    private onNotAdjacentOrbsSelected(): void {

        GameVars.orbsMoving = false;

        BoardContainer.currentInstance.onNotAdjacentOrbsSelected();

        this.p1 = null;
        this.p2 = null;
    }

}
